module.exports = __webpack_public_path__ + "img/global.a2758636.svg";